import React from "react";
import { Box, Typography } from "@mui/material";

export default function SummaryTile({
  label,
  amount,
  count,
  amountVariant = "h5",
  sx,
}) {
  return (
    <Box
      sx={{
        flex: "1 0 120px",
        minWidth: 120,
        p: 2,
        position: "relative",
        borderRadius: 1,
        bgcolor: "#FFFFFF",
        textAlign: "center",
        ...sx,
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ position: "absolute", top: 8, right: 8 }}
      >
        {count.toLocaleString()}
      </Typography>
      <Typography variant={amountVariant} sx={{ lineHeight: 1.2, mt: 1.25 }}>
        {amount}
      </Typography>
      <Typography
        variant="overline"
        color="text.secondary"
        display="block"
        noWrap
        title={label}
        sx={{ lineHeight: 1.4, mt: 0.75 }}
      >
        {label}
      </Typography>
    </Box>
  );
}
